import axios from 'axios';
import router from '@/router'; // Import the router

const state = {
    user: null,
    navList: []
};

const getters = {
    isAuthenticated: (state) => !!state.user
};

const actions = {
    // NEW: Action to check session status on app startup
    async CheckAuth({ commit }) {
        try {
            const response = await axios.get('/auth/status');
            commit('setAuthState', response.data);
        } catch (error) {
            // If we get an error (likely 401), ensure we are logged out
            commit('clearAuthState');
        }
    },

    async LogIn({ commit }, userCredentials) {
        // The POST to login returns the user on success
        const response = await axios.post('/auth/login', userCredentials);

        // Now fetch the navlist
        const navListResponse = await axios.get('/auth/navlist');

        // Commit everything at once
        commit('setAuthState', {
            user: { username: response.data.username }, // Use response from login
            navList: navListResponse.data
        });

        // Redirect to home after successful login
        if (router.currentRoute.path !== '/') {
            router.push('/');
        }
    },

    async LogOut({ commit }){
        // Clear backend session first
        await axios.get('/auth/logout');

        // Clear local state
        commit('clearAuthState');

        // Redirect to login page
        if (router.currentRoute.path !== '/login') {
            router.push('/login');
        }
    }
};

const mutations = {
    // A single mutation to set the entire authenticated state
    setAuthState(state, { user, navList }) {
        state.user = user.username; // Or the full user object if you prefer
        state.navList = navList;
    },

    // A single mutation to clear the entire state
    clearAuthState(state){
        state.user = null;
        state.navList = [];
    },
};

export default {
    state,
    getters,
    actions,
    mutations
};